import { isMacOs, isWindows } from 'react-device-detect';
import { isFlowUsApp } from './electron-util';

export const isMacElectron = isMacOs && isFlowUsApp.check;
export const isWinElectron = isWindows && isFlowUsApp.check;
